import { GET_ADDRATECARD, GET_RATECARD,GET_TRIPPRICE , GET_COMPANYDUTY, GET_COMPANYLOCATION, GET_SUBCITY } from "resources/actionTypes";

const intialState = {
  userRateCard: [],
  loading: false,
  error: null,
};
const intialStateAdd = {
  userAddRateCard: [],
  loading: false,
  error: null,
}

const initailGetTrip = {
  loading: false,
  error: null,
  userGetTripPrice: '',
}

const intialCompanyLocationState = {
  userCompanyLocation: [],
  loading: false,
  error: null,
};

const initialCompanyDutyState = {
  userCompanyDuty: [],
  loading: false,
  error: null,
};

const initialSubCity = {
  userSubCity: [],
  loading: false,
  error: null,
};


export function userRateCard(state = intialState, action) {
  switch (action.type) {
    case GET_RATECARD.GET_RATECARD_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case GET_RATECARD.GET_RATECARD_SUCCESS:
      return {
        ...state,
        loading: false,
        userRateCard: action.userRateCard,
      }
    case GET_RATECARD.GET_RATECARD_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      }
      case GET_RATECARD.GET_RATECARD_CLEAR:
        return {
          ...state,
          loading: false,
          userRateCard: ""
        }
    default:
      return state;
  }
}

export function userAddRateCard(state = intialStateAdd, action) {
  switch (action.type) {
    case GET_ADDRATECARD.GET_ADDRATECARD_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case GET_ADDRATECARD.GET_ADDRATECARD_SUCCESS:
      return {
        ...state,
        loading: false,
        userAddRateCard: action.userAddRateCard,
      }
    case GET_ADDRATECARD.GET_ADDRATECARD_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      }
    default:
      return state;
  }
}

export function userGetTripPrice(state = initailGetTrip, action) {
  switch (action.type) {
    case GET_TRIPPRICE.GET_TRIPPRICE_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case GET_TRIPPRICE.GET_TRIPPRICE_SUCCESS:
      return {
        ...state,
        loading: false,
        userGetTripPrice: action.getTripRate,
      }
    case GET_TRIPPRICE.GET_TRIPPRICE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      }
    default:
      return state;
  }
}

export function userCompanyDuty(state = initialCompanyDutyState, action) {
  switch (action.type) {
    case GET_COMPANYDUTY.GET_COMPANYDUTY_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case GET_COMPANYDUTY.GET_COMPANYDUTY_SUCCESS:
      return {
        ...state,
        loading: false,
        userCompanyDuty: action.userCompanyDuty,
      }
    case GET_COMPANYDUTY.GET_COMPANYDUTY_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      }
      case GET_COMPANYDUTY.GET_COMPANYDUTY_CLEAR:
        return {
          ...state,
          userCompanyDuty: "",
        }
    default:
      return state;
  }
}

export function userCompanyLocation(state = intialCompanyLocationState, action) {
  switch (action.type) {
    case GET_COMPANYLOCATION.GET_COMPANYLOCATION_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case GET_COMPANYLOCATION.GET_COMPANYLOCATION_SUCCESS:
      return {
        ...state,
        loading: false,
        userCompanyLocation: action.userCompanyLocation,
      }
    case GET_COMPANYLOCATION.GET_COMPANYLOCATION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      }
      case GET_COMPANYLOCATION.GET_COMPANYLOCATION_CLEAR:
      return {
        ...state,
        userCompanyLocation: "",
      }
    default:
      return state;
  }
}

export function userSubCity(state = initialSubCity, action) {
  switch (action.type) {
    case GET_SUBCITY.GET_SUBCITY_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case GET_SUBCITY.GET_SUBCITY_SUCCESS:
      return {
        ...state,
        loading: false,
        userSubCity: action.userSubCity,
      }
    case GET_SUBCITY.GET_SUBCITY_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      }
      case GET_SUBCITY.GET_SUBCITY_CLEAR:
      return {
        ...state,
        userSubCity: "",
      }
    default:
      return state;
  }
}
